module.exports = __webpack_public_path__ + "static/media/burnley.9476f3ac.png";